import { fetchGetTokenized } from "api/common/callerHelpers";

export const getTestTemplates = async () => {
  return await fetchGetTokenized("/api/templates/select-list");
};
